import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Drama from "../pages/drama/page";
import Search from "../pages/search/page";
import Vip from "../pages/vip/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/drama/:id",
    element: <Drama />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/vip",
    element: <Vip />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;